import { Pipe, PipeTransform } from '@angular/core';

import { Staff } from '../../shared/dataModels/staff';

@Pipe({ name: "StaffFilter" })
export class StaffFilterPipe implements PipeTransform {

    transform(StaffList: Staff[], key: string): Staff[] {

        if (!key) {
            return StaffList;
        }

        if (StaffList) {

            //Single Character
            if (key.length == 1) {

                var firstMatch = StaffList.filter(trans => trans.FirstName.trim().charAt(0).toLowerCase() == key.trim().toLowerCase());

                if (firstMatch && firstMatch.length > 0) {
                    return firstMatch;
                }
            }

            return StaffList.filter(trans =>
                ((trans.FirstName.trim().toLowerCase().startsWith(key.trim().toLowerCase()))));

        }

        return StaffList;
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/pipes/staff-filter.pipe.ts